import { Colors, Media } from 'enums';
import styled from 'styled-components';

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${Media.notebook} {
    gap: 40px;
  }
`;

export const ModalNoticeWrapper = styled.div`
  word-break: break-word;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Media.notebook} {
    gap: 32px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${Media.notebook} {
    gap: 24px;
  }

  input {
    background-color: ${Colors.gray5};
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${Media.notebook} {
    gap: 16px;
  }

  strong {
    font-weight: 600;
  }
`;
